export default __webpack_public_path__ + "static/media/arras14.cac8fbbd.jpg";